import HELPER from '@/app/utils/HELPER';
import { getCurrency } from '@/app/utils/helpers';
import { getFontWeightDesignOption, getFontWeightBoldValue } from '@/app/utils/settingFontWeight';

export default function ($element, $activePanel, _this, $self, moduleName, style, screenType, $input) {
  // TODO(thanhdx): get selector for adding global style class to module here
  let changed = true;
  const devices = ['xs', 'sm', 'md', 'lg'];
  // COLLECTION 2019
  let inputId = undefined;
  if ($input) {
    inputId = $input.attr('id') ? $input.attr('id') : $input.attr('name');
  }

  switch (moduleName) {
    case 'Popup':
      switch (inputId) {
        case 'fullScreen-lg':
        case 'fullScreen-md':
        case 'fullScreen-sm':
        case 'fullScreen-xs': {
          let popupWidth = 'auto';
          let popupHeight = 'auto';
          const fullScreen = $activePanel.find(`#fullScreen-${screenType}`).val();
          const minWidth = HELPER.getValueFromCSS($self, style, 'min-width', screenType);
          const minHeight = HELPER.getValueFromCSS($self, style, 'min-height', screenType);
          if (fullScreen == '1') {
            popupWidth = '100%';
            popupHeight = '100%';
          } else {
            popupWidth = minWidth;
            popupHeight = minHeight;
          }
          $activePanel.find('input[name="width"]').val(popupWidth).attr('value', popupWidth).trigger('value-change');
          $activePanel.find('input[name="height"]').val(popupHeight).attr('value', popupHeight).trigger('value-change');
          const deOptions = [
            {
              key: 'width',
              value: popupWidth,
            },
            {
              key: 'height',
              value: popupHeight,
            },
            {
              key: 'max-width',
              value: popupWidth,
            },
            {
              key: 'max-height',
              value: popupHeight,
            },
          ];
          style = HELPER.designOptions2Style($element, screenType, style, deOptions, '.module-wrap');
        }
        case 'width': {
          let width = jQuery.trim($activePanel.find('input[name="width"]').val());
          const height = jQuery.trim($activePanel.find('input[name="height"]').val());
          if (width == 'auto') {
            width = '';
          }
          let deOptions = [];
          if (width == '100%') {
            deOptions = [
              {
                key: 'width',
                value: width,
              },
              {
                key: 'max-width',
                value: width,
              },
            ];
          } else {
            deOptions = [
              {
                key: 'width',
                value: width,
              },
              {
                key: 'min-width',
                value: width,
              },
            ];
          }
          if (width == '100%' && height == '100%') {
            $activePanel.find(`#fullScreen-${screenType}`).val('1').attr('value', '1').trigger('value-change');
          } else {
            $activePanel.find(`#fullScreen-${screenType}`).val(0).attr('value', 0).trigger('value-change');
          }
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.module-wrap');
          break;
        }
        case 'height': {
          const width = jQuery.trim($activePanel.find('input[name="width"]').val());
          let height = jQuery.trim($activePanel.find('input[name="height"]').val());
          if (height == 'auto') {
            height = '';
          }
          let deOptions = [];
          if (height == '100%') {
            deOptions = [
              {
                key: 'height',
                value: height,
              },
              {
                key: 'max-height',
                value: height,
              },
            ];
          } else {
            deOptions = [
              {
                key: 'height',
                value: height,
              },
              {
                key: 'min-height',
                value: height,
              },
            ];
          }
          if (width == '100%' && height == '100%') {
            $activePanel.find(`#fullScreen-${screenType}`).val('1').attr('value', '1').trigger('value-change');
          } else {
            $activePanel.find(`#fullScreen-${screenType}`).val(0).attr('value', 0).trigger('value-change');
          }
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.module-wrap');
          break;
        }
        case 'padding':
          var deOptions = [
            {
              key: 'padding',
              value: $activePanel.find('#padding').val(),
            },
          ];
          var classModule = '> .module';
          var $selfModule = $self.find(classModule);
          style = HELPER.designOptions2Style($selfModule, screenType, style, deOptions, classModule);
          break;
        case 'closeBtnColor':
          var deOptions = [
            {
              key: 'fill',
              value: $activePanel.find('#closeBtnColor').val(),
            },
          ];
          var classBtnClose = '.gf-closePopup';
          var $selfBtnClose = $self.find(classBtnClose);
          style = HELPER.designOptions2Style($selfBtnClose, screenType, style, deOptions, classBtnClose);
          break;
        case 'closeBtnBg':
          var deOptions = [
            {
              key: 'background-color',
              value: $activePanel.find('#closeBtnBg').val(),
            },
          ];
          var classBtnClose = '.gf-closePopup';
          var $selfBtnClose = $self.find(classBtnClose);
          style = HELPER.designOptions2Style($selfBtnClose, screenType, style, deOptions, classBtnClose);
          break;
        case 'closePostion': {
          const classBtnClose = '.gf-closePopup';
          const classBtnIconClose = '.gf-closePopup svg';
          const $selfBtnClose = $self.find(classBtnClose);
          const closeBtnRadius = $activePanel.find('#closeBtnRadius').val();
          const closeBtnIconSize = $activePanel.find('#closeBtnIconSize').val();
          const deOptionsIcon = [
            {
              key: 'width',
              value: closeBtnIconSize,
            },
            {
              key: 'height',
              value: closeBtnIconSize,
            },
          ];
          style = HELPER.designOptions2Style($selfBtnClose, screenType, style, deOptionsIcon, classBtnIconClose);
          const deOptionsOut = [
            {
              key: 'right',
              value: '-' + (parseInt($activePanel.find('#closeBtnSize').val()) / 2 - 4) + 'px',
            },
            {
              key: 'top',
              value: '-' + (parseInt($activePanel.find('#closeBtnSize').val()) / 2 - 4) + 'px',
            },
            {
              key: 'width',
              value: $activePanel.find('#closeBtnSize').val(),
            },
            {
              key: 'height',
              value: $activePanel.find('#closeBtnSize').val(),
            },
            {
              key: 'border-radius',
              value: closeBtnRadius,
            },
          ];
          style = HELPER.designOptions2Style($selfBtnClose, screenType, style, deOptionsOut, classBtnClose);
          break;
        }
        case 'closeBtnSize':
          var deOptions = [
            {
              key: 'right',
              value: '-' + (parseInt($activePanel.find('#closeBtnSize').val()) / 2 - 4) + 'px',
            },
            {
              key: 'top',
              value: '-' + (parseInt($activePanel.find('#closeBtnSize').val()) / 2 - 4) + 'px',
            },
            {
              key: 'width',
              value: $activePanel.find('#closeBtnSize').val(),
            },
            {
              key: 'height',
              value: $activePanel.find('#closeBtnSize').val(),
            },
          ];
          var classBtnClose = '.gf-closePopup';
          var $selfBtnClose = $self.find(classBtnClose);
          style = HELPER.designOptions2Style($selfBtnClose, screenType, style, deOptions, classBtnClose);
          break;
        case 'closeBtnRadius':
          var deOptions = [
            {
              key: 'border-radius',
              value: $activePanel.find('#closeBtnRadius').val(),
            },
          ];
          var classBtnClose = '.gf-closePopup';
          var $selfBtnClose = $self.find(classBtnClose);
          style = HELPER.designOptions2Style($selfBtnClose, screenType, style, deOptions, classBtnClose);
          break;
        case 'closeBtnIconSize':
          var deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#closeBtnIconSize').val(),
            },
            {
              key: 'height',
              value: $activePanel.find('#closeBtnIconSize').val(),
            },
          ];
          var classBtnIconClose = '.gf-closePopup svg';
          var $selfBtnIconClose = $self.find(classBtnIconClose);
          style = HELPER.designOptions2Style($selfBtnIconClose, screenType, style, deOptions, classBtnIconClose);
          break;
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }
      break;

    case 'Video Bg':
      switch (inputId) {
        case 'image':
          var deOptions = [
            {
              key: 'background-image',
              value:
                $activePanel.find('#image').val() != ''
                  ? HELPER.getImageBgOption($activePanel.find('#image').val())
                  : 'none',
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }

      break;
    case 'LAI AliExpress Reviews':
      switch (inputId) {
        case 'widget': {
          if (!window.gemDragging) {
            window.gemDragging = {};
            window.gemDragging.newLAI = [];
          }
          if (window.gemDragging && window.gemDragging.newLAI && window.gemDragging.newLAI.length >= 0) {
            const newLocal = window.gemDragging.newLAI || [];
            const moduleId = $element.attr('id');
            if (newLocal && newLocal.length > 0) {
              const index = newLocal.findIndex((x) => x.id == moduleId);
              if (index > -1) {
                newLocal[index].status = 'update';
              }
              try {
                window.gemDragging.newLAI = JSON.parse(JSON.stringify(newLocal));
              } catch (err) {}
            }
          }
        }
      }
      break;
    case 'Ali Reviews':
      switch (inputId) {
        case 'v6widget': {
          const currentVer = $activePanel.find('#ali_version').val();
          if (currentVer == 'v6') {
            const $gfFrame = jQuery('#gfFrame');
            const $divContentBk = $gfFrame.contents().find('#divContentBk');
            const moduleId = $element.attr('data-id');
            const $bkActiveModule = $divContentBk.find('#module-' + moduleId);
            const $settings = $bkActiveModule.find('.settings');
            const settingData = $settings.html();
            try {
              const fields = JSON.parse(settingData);
              if (fields) {
                const v6widgetOption = fields.find((e) => e.id == 'v6widget').options;
                const widgetSelected = $activePanel.find('#v6widget').val();
                if (v6widgetOption && widgetSelected !== 'section') {
                  const optionName = v6widgetOption[widgetSelected];
                  $element.children('.module').attr('data-aliname', optionName);
                  $activePanel
                    .find('#arv6SectionName')
                    .val(optionName)
                    .attr('value', optionName)
                    .trigger('value-change');
                }
              }
            } catch (err) {
              console.log(err);
            }
          }
          break;
        }
        default:
          changed = false;
      }

      break;

    case 'Google Map':
    case 'Google Maps':
      switch (inputId) {
        case 'height':
          var height = jQuery.trim($activePanel.find('input[name="height"]').val());
          var deOptions = [];
          if (height != undefined) {
            if (height != '' && height != 'auto') {
              deOptions.push({
                key: 'height',
                value: height,
              });
            } else {
              deOptions.push({
                key: 'height',
                value: '400px',
              });
            }
          }
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }

      break;

    case 'Count Down':
    case 'Countdown Timer':
      switch (inputId) {
        // case 'dateEvergreenLoop': {
        //     const loopOn = $activePanel.find('#dateEvergreenLoop').val();
        //     const switchAutoHide = $activePanel.find("#generalAutoHide").data("gfswitcher");
        //     if (loopOn + "" == 1) {
        //         switchAutoHide.setValue(0);
        //         switchAutoHide.getController().hide();
        //     } else {
        //         switchAutoHide.getController().show();
        //     }
        //     break;
        // }

        case 'number-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#number-size').val(),
            },
          ];
          var classNumber = '.module .num';
          var $selfNumber = $self.find(classNumber);
          style = HELPER.designOptions2Style($selfNumber, screenType, style, deOptions, classNumber);
          break;
        case 'number-font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#number-font').val(),
            },
          ];
          var classNumber = '.module .num';
          var $selfNumber = $self.find(classNumber);
          style = HELPER.designOptions2Style($selfNumber, screenType, style, deOptions, classNumber);
          break;
        case 'number-color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#number-color').val(),
            },
          ];
          var classNumber = '.module .num';
          var $selfNumber = $self.find(classNumber);
          style = HELPER.designOptions2Style($selfNumber, screenType, style, deOptions, classNumber);
          break;
        case 'vertical-gap':
          var deOptions = [
            {
              key: 'padding-bottom',
              value: $activePanel.find('#vertical-gap').val(),
            },
          ];
          var classNumber = '.module .num';
          var $selfNumber = $self.find(classNumber);
          style = HELPER.designOptions2Style($selfNumber, screenType, style, deOptions, classNumber);
          break;
        case 'text-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#text-size').val(),
            },
          ];
          var classText = '.module .count-label';
          var $selfText = $self.find(classText);
          style = HELPER.designOptions2Style($selfText, screenType, style, deOptions, classText);
          break;
        case 'text-font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#text-font').val(),
            },
          ];
          var classText = '.module .count-label';
          var $selfText = $self.find(classText);
          style = HELPER.designOptions2Style($selfText, screenType, style, deOptions, classText);
          break;
        case 'text-color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#text-color').val(),
            },
          ];
          var classText = '.module .count-label';
          var $selfText = $self.find(classText);
          style = HELPER.designOptions2Style($selfText, screenType, style, deOptions, classText);
          break;
        case 'horizontal-gap':
          var deOptions = [
            {
              key: 'padding',
              value: $activePanel.find('#horizontal-gap').val(),
            },
          ];
          var classHorizontal = '.module .time-left';
          var $selfHorizontal = $self.find(classHorizontal);
          style = HELPER.designOptions2Style($selfHorizontal, screenType, style, deOptions, classHorizontal);
          break;

        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }
      break;

    case 'Counter':
      switch (inputId) {
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'line-height':
          var deOptions = [
            {
              key: 'line-height',
              value: $activePanel.find('#line-height').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }

      break;

    case 'Hero Banner':
      switch (inputId) {
        case 'image':
          var deOptions = [
            {
              key: 'background-image',
              value:
                $activePanel.find('#image').val() != ''
                  ? HELPER.getImageBgOption($activePanel.find('#image').val())
                  : 'none',
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'height':
          var height = jQuery.trim($activePanel.find('input[name="height"]').val());
          if (height != undefined) {
            var deOptions = [];
            if (height != '' && height != 'auto') {
              var dragPlaceHolder = 50;

              deOptions.push(
                {
                  key: 'height',
                  value: height,
                },
                {
                  key: 'padding-top',
                  value: parseFloat(height) / 2 - dragPlaceHolder / 2 + 'px',
                },
                {
                  key: 'padding-bottom',
                  value: '10px',
                },
              );
            } else {
              var paddingTop = HELPER.getValueFromCSS($self, style, 'padding-top', screenType);
              var paddingBottom = HELPER.getValueFromCSS($self, style, 'padding-bottom', screenType);

              if (parseInt(paddingBottom) == 10) {
                paddingBottom = paddingTop;

                var dragPlaceHolder = 50;

                deOptions.push(
                  {
                    key: 'height',
                    value: 'auto',
                  },
                  {
                    key: 'padding-top',
                    value: parseInt(paddingTop) + 'px',
                  },
                  {
                    key: 'padding-bottom',
                    value: parseInt(paddingBottom) + 'px',
                  },
                );
              }
            }
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          } else {
            changed = false;
          }
          break;
        default:
          changed = false;
      }

      setTimeout(function () {
        $element.data('gfoutline').updatePadding('top');
        $element.data('gfoutline').updatePadding('bottom');
      }, 300);

      if (changed) {
        _this.runStyle(style);
      }
      break;

    case 'Tabs':
      switch (inputId) {
        case 'height':
          var height = jQuery.trim($activePanel.find('input[name="height"]').val());
          var deOptions = [
            {
              key: 'height',
              value: height,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'tab-padding-x':
        case 'tab-padding-y': {
          const paddingX = jQuery.trim($activePanel.find('input[name="tab-padding-x"]').val());
          const paddingY = jQuery.trim($activePanel.find('input[name="tab-padding-y"]').val());
          const paddingValue = `${paddingY} ${paddingX}`;
          var deOptions = [
            {
              key: 'padding',
              value: paddingValue,
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_tab').find('.item-content'),
            screenType,
            style,
            deOptions,
            '> .gf_restabs >ul >li > span:first-child',
          );
          break;
        }
        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }
      break;

    case 'Product List':
      switch (inputId) {
        case 'sameHeight':
        case 'height':
          var sameHeight = $activePanel.find('#sameHeight').val();
          if (sameHeight == '1') {
            var productHeight = $activePanel.find('#height').val();
          } else {
            var productHeight = 'auto';
          }
          var deOptions = [
            {
              key: 'height',
              value: productHeight,
            },
          ];
          // Create two styles because you have to fix the old customer's style
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.module>a.img-holder',
          );
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.module>.img-holder',
          );
          break;
        case 'sameTitleHeight':
        case 'titleHeight':
          var sameTitleHeight = $activePanel.find('#sameTitleHeight').val();
          if (sameTitleHeight == '1') {
            var productHeight = $activePanel.find('#titleHeight').val();
          } else {
            var productHeight = 'auto';
          }
          var deOptions = [
            {
              key: 'height',
              value: productHeight,
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.gf_product-title',
          ); // (P) Title
          break;
        case 'spacing_xs':
          var spacing = $activePanel.find(`#spacing_xs`).val();
          var deOptions = [
            {
              key: 'padding',
              value: spacing,
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.gf_module-spacing-xs',
          );
          break;
        case 'spacing_sm':
          var spacing = $activePanel.find(`#spacing_sm`).val();
          var deOptions = [
            {
              key: 'padding',
              value: spacing,
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.gf_module-spacing-sm',
          );
          break;
        case 'spacing_md':
          var spacing = $activePanel.find(`#spacing_md`).val();
          var deOptions = [
            {
              key: 'padding',
              value: spacing,
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.gf_module-spacing-md',
          );
          break;
        case 'spacing_lg':
          var spacing = $activePanel.find(`#spacing_lg`).val();
          var deOptions = [
            {
              key: 'padding',
              value: spacing,
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.gf_module-spacing-lg',
          );
          break;
        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }

      break;
    case 'Related Products':
      switch (inputId) {
        case 'sameImageHeight':
        case 'imageHeight':
          var sameImageHeight = $activePanel.find('#sameImageHeight').val();
          if (sameImageHeight == '1') {
            var productHeight = $activePanel.find('#imageHeight').val();
          } else {
            var productHeight = 'auto';
          }
          var deOptions = [
            {
              key: 'height',
              value: productHeight,
            },
          ];
          // Create two styles because you have to fix the old customer's style
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.module>a.img-holder',
          );
          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.module>.img-holder',
          );
          break;
        case 'sameTitleHeight':
        case 'titleHeight':
          var sameTitleHeight = $activePanel.find('#sameTitleHeight').val();
          if (sameTitleHeight == '1') {
            var productHeight = $activePanel.find('#titleHeight').val();
          } else {
            var productHeight = 'auto';
          }
          var deOptions = [
            {
              key: 'height',
              value: productHeight,
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.item-content'),
            screenType,
            style,
            deOptions,
            '.gf_product-title',
          );
          break;
        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }

      break;
    case '(P) Title':
    case '(P) Vendor':
    case '(P) SKU':
    case '(P) Description':
    case '(A) Title':
    case '(A) Content':
    case '(A) Excerpt':
    case '(A) Date':
      switch (inputId) {
        case 'titleTag':
          var defaultFontWeight = $self.parent().css('font-weight');
          var fontStyleVal = $activePanel.find('#font-style').val();
          var defaultVal = defaultFontWeight;
          if (defaultFontWeight) {
            if (defaultFontWeight == 'bold' || parseFloat(defaultFontWeight) == 700) {
              fontStyleVal = 'bold';
              defaultVal = 'bold';
            } else if (parseFloat(defaultFontWeight) < 700 && fontStyleVal) {
              fontStyleVal = fontStyleVal.replace('bold', '');
              defaultVal = defaultFontWeight;
            }
            $activePanel.find('#font-style').val(fontStyleVal).attr('value', fontStyleVal).trigger('value-change');
            $activePanel.find('#fontWeight').val(defaultVal).attr('value', defaultVal).trigger('value-change');
            var deOptions = [
              {
                key: 'font-weight',
                value: defaultVal,
              },
            ];
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          }
          break;
        case 'font-style':
          var fontItalic = '';
          var fontWeight = '';
          var fontUnderline = '';
          var fontStyle = $activePanel.find('#font-style').val();
          var dataPrevious = $activePanel.find('#fontWeight').attr('data-previous');
          var dataDefault = $activePanel.find('#fontWeight').attr('default_value');
          if (fontStyle && !fontStyle.includes('bold')) {
            const revertData = dataPrevious ? dataPrevious : dataDefault;
            $activePanel.find('#fontWeight').val(revertData).attr('value', revertData).trigger('value-change');
            fontWeight = $activePanel.find('#fontWeight').val();
          }
          fontStyle = HELPER.trim(fontStyle, ',');
          var arrayFontStyle = fontStyle.split(',');
          var multiDecoration = '';
          for (var v = 0; v < arrayFontStyle.length; v++) {
            if (arrayFontStyle[v] == 'underline' || arrayFontStyle[v] == 'line-through') {
              multiDecoration += ' ' + arrayFontStyle[v];
            }
            switch (arrayFontStyle[v]) {
              case 'bold':
                fontWeight = 'bold';
                $activePanel.find('#fontWeight').val(fontWeight).attr('value', fontWeight).trigger('value-change');

                break;
              case 'italic':
                fontItalic = 'italic';
                break;
            }
          }

          var deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: multiDecoration,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'line-height':
          var deOptions = [
            {
              key: 'line-height',
              value: $activePanel.find('#line-height').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'letter-spacing':
          var deOptions = [
            {
              key: 'letter-spacing',
              value: $activePanel.find('#letter-spacing').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'text-transform':
          var deOptions = [
            {
              key: 'text-transform',
              value: $activePanel.find('#text-transform').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'fontWeight':
          var fontStyleVal = $activePanel.find('#font-style').val();
          var fontWeight = $activePanel.find('#fontWeight').val();
          $activePanel.find('#fontWeight').attr('data-previous', fontWeight);
          $activePanel.find('#fontWeight').trigger('value-change');
          if (fontStyleVal) {
            if (fontWeight == 'bold' || parseFloat(fontWeight) == 700) {
              fontStyleVal = 'bold';
            } else if (parseFloat(fontWeight) < 700) {
              fontStyleVal = fontStyleVal.replace('bold', '');
            }
            $activePanel.find('#font-style').val(fontStyleVal).attr('value', fontStyleVal).trigger('value-change');
          }
          var deOptions = [
            {
              key: 'font-weight',
              value: $activePanel.find('#fontWeight').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'truncate_xs':
        case 'truncate_sm':
        case 'truncate_md':
        case 'truncate_lg':
        case 'ln_xs':
        case 'ln_sm':
        case 'ln_md':
        case 'ln_lg':
          var lineHeight = $self.css('line-height');
          var truncStyle = $activePanel.find(`#truncate_${screenType} option:selected`).attr('value') || 'none';
          var lineNumber = $activePanel.find(`#ln_${screenType}`).attr('value') || 2;
          var maxHeight = parseFloat(lineHeight) * parseFloat(lineNumber);
          maxHeight += 'px';
          if (truncStyle == 'lc_fade') {
            $self.css('max-height', maxHeight);
            var deOptions = [
              {
                key: 'max-height',
                value: maxHeight,
              },
              {
                key: '-webkit-line-clamp',
                value: 'unset',
              },
            ];
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          } else if (truncStyle == 'line_clamp') {
            let lineClamp = parseFloat(lineNumber) || 2;
            lineClamp += '';
            $self.css('-webkit-line-clamp', lineClamp);
            var deOptions = [
              {
                key: '-webkit-line-clamp',
                value: lineClamp,
              },
              {
                key: 'max-height',
                value: 'unset',
              },
            ];
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          }
          // var deOptions = [{
          //     'key': '',
          //     'value': ''
          //   }];
          //   style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }
      break;

    case '(P) Price':
      switch (inputId) {
        case 'font-style':
          var fontItalic = '';
          var fontWeight = getFontWeightBoldValue({ $activePanel });
          var fontUnderline = '';
          var fontStyle = $activePanel.find('#font-style').val();

          fontStyle = HELPER.trim(fontStyle, ',');
          var arrayFontStyle = fontStyle.split(',');
          for (var v = 0; v < arrayFontStyle.length; v++) {
            switch (arrayFontStyle[v]) {
              case 'bold':
                fontWeight = 'bold';
                break;
              case 'italic':
                fontItalic = 'italic';
                break;
              case 'underline':
                fontUnderline = 'underline';
                break;
            }
          }

          var deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: fontUnderline,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;

        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'fontWeight':
          var deOptions = [getFontWeightDesignOption({ $activePanel })];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;

        case 'color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'compare-font-weight':
          var deOptions = [getFontWeightDesignOption({ $activePanel, inputSelector: '#compare-font-weight' })];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-compare-price');
          break;
        case 'compare-style':
          var fontItalic = '';
          var fontWeight = getFontWeightBoldValue({ $activePanel, inputSelector: '#compare-font-weight' });
          var fontStyle = $activePanel.find('#compare-style').val();

          fontStyle = HELPER.trim(fontStyle, ',');
          var arrayFontStyle = fontStyle.split(',');
          for (var v = 0; v < arrayFontStyle.length; v++) {
            switch (arrayFontStyle[v]) {
              case 'bold':
                fontWeight = 'bold';
                break;
              case 'italic':
                fontItalic = 'italic';
                break;
            }
          }
          var deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-compare-price');

          break;

        case 'compare-color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#compare-color').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-compare-price');
          break;

        case 'compare-font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#compare-font').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-compare-price');
          break;

        case 'line-through':
        case 'line-through-color':
        case 'line-through-position':
        case 'compare-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#compare-size').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-compare-price');

          var lineThrough = $activePanel.find('#line-through').val();
          var lineThroughColor = '';
          var lineThroughPosition = '';
          var lineThroughSize = '0px';

          if (lineThrough == '1' || lineThrough == 1) {
            lineThroughColor = $activePanel.find('#line-through-color').val();
            lineThroughPosition = $activePanel.find('#line-through-position').val();

            const compareSize = $activePanel.find('#compare-size').val();
            if (compareSize) {
              lineThroughSize = parseInt(compareSize) * 0.06;
              if (lineThroughSize <= 1) {
                lineThroughSize = 1;
              }
              lineThroughSize = lineThroughSize + 'px';
            }
          }

          var deOptions = [
            {
              key: 'background',
              value: lineThroughColor,
            },
            {
              key: 'transform',
              value: 'translateY(' + lineThroughPosition + ')',
            },
            {
              key: 'height',
              value: lineThroughSize,
            },
            getFontWeightDesignOption({ $activePanel }),
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-compare-price:after');
          break;

        case 'percent-discount':
        case 'percent-discount-padding':
        case 'percent-discount-border-color':
        case 'percent-discount-border-size':
        case 'percent-discount-border-style':
        case 'percent-discount-style':
        case 'percent-discount-size':
        case 'percent-discount-color':
        case 'percent-discount-font':
        case 'percent-discount-background':
          var percent = $activePanel.find('#percent-discount').val();
          if (percent == '1' || percent == 1) {
            const percentPadding = $activePanel.find('#percent-discount-padding').val();
            const percentBorderColor = $activePanel.find('#percent-discount-border-color').val();
            const percentBorderSize = $activePanel.find('#percent-discount-border-size').val();
            const percentBorderStyle = $activePanel.find('#percent-discount-border-style').val();

            // Font Style
            let fontPercentItalic = '';
            let fontPercentWeight = '';
            let fontPercentUnderline = '';
            let fontPercentStyle = $activePanel.find('#percent-discount-style').val();
            if (fontPercentStyle) {
              fontPercentStyle = HELPER.trim(fontPercentStyle, ',');
              const arrayFontPercentStyle = fontPercentStyle.split(',');
              for (let b = 0; b < arrayFontPercentStyle.length; b++) {
                switch (arrayFontPercentStyle[b]) {
                  case 'bold':
                    fontPercentWeight = 'bold';
                    break;
                  case 'italic':
                    fontPercentItalic = 'italic';
                    break;
                  case 'underline':
                    fontPercentUnderline = 'underline';
                    break;
                }
              }
            }

            var deOptions = [
              {
                key: 'padding',
                value: percentPadding,
              },
              {
                key: 'border-color',
                value: percentBorderColor,
              },
              {
                key: 'border-width',
                value: percentBorderSize,
              },
              {
                key: 'border-style',
                value: percentBorderStyle,
              },
              {
                key: 'font-size',
                value: $activePanel.find('#percent-discount-size').val(),
              },
              {
                key: 'color',
                value: $activePanel.find('#percent-discount-color').val(),
              },
              {
                key: 'background',
                value: $activePanel.find('#percent-discount-background').val(),
              },
              {
                key: 'font-family',
                value: $activePanel.find('#percent-discount-font').val(),
              },
              {
                key: 'font-weight',
                value: fontPercentWeight,
              },
              {
                key: 'font-style',
                value: fontPercentItalic,
              },
              {
                key: 'text-decoration',
                value: fontPercentUnderline,
              },
            ];
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_pq-discount');
          } else {
            changed = false;
          }
          break;

        case 'percent-discount-gaps':
          var deOptions = [
            {
              key: 'padding-left',
              value: $activePanel.find('#percent-discount-gaps').val(),
            },
            {
              key: 'padding-right',
              value: $activePanel.find('#percent-discount-gaps').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_pq-discount-selector');
          break;

        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }
      break;
    case 'Breadcrumbs':
    case '(P) Dynamic Checkout Button':
    case '(P) Cart Button':
    case '(P) View More':
    case 'Social Share':
      switch (inputId) {
        case 'width':
          var deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'height':
          var deOptions = [
            {
              key: 'height',
              value: $activePanel.find('#height').val(),
            },
            {
              key: 'line-height',
              value: $activePanel.find('#height').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'texttransform':
          var deOptions = [
            {
              key: 'text-transform',
              value: $activePanel.find('#texttransform').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'button-color':
          var buttonColor = $activePanel.find('#button-color').val();
          if (moduleName == '(P) View More') {
            $self.parent('.gf_view-more').css('background-color', buttonColor);
          }
          if (
            moduleName == '(P) Cart Button' ||
            moduleName == '(P) Dynamic Checkout Button' ||
            moduleName == '(P) View More'
          ) {
            deOptions = [
              {
                key: 'background-color',
                value: buttonColor,
              },
            ];
          } else {
            changed = false;
          }

          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'buttonHover':
          if ($activePanel.find('[name="buttonHover"]').val() != 1) {
            deOptions = [
              {
                key: 'background-color',
                value: '',
              },
              {
                key: 'color',
                value: '',
              },
            ];
            switch (moduleName) {
              case '(P) View More':
                style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_view-more:hover');
                break;
              case '(P) Dynamic Checkout Button':
                style = HELPER.designOptions2Style(
                  $self,
                  screenType,
                  style,
                  deOptions,
                  '.shopify-payment-button__button:hover',
                );
                break;
              default:
                style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_add-to-cart:hover');
                break;
            }
          }
          break;
        case 'button-color-hover':
        case 'color-hover':
          if ($activePanel.find('[name="button-color-horver"]').length > 0) {
            if (
              moduleName == '(P) Cart Button' ||
              moduleName == '(P) Dynamic Checkout Button' ||
              moduleName == '(P) View More'
            ) {
              deOptions = [
                {
                  key: 'background-color',
                  value: $activePanel.find('[name="button-color-horver"]').val(),
                },
                {
                  key: 'color',
                  value: $activePanel.find('[name="color-horver"]').val(),
                },
              ];
              switch (moduleName) {
                case '(P) View More':
                  style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_view-more:hover');
                  break;
                case '(P) Dynamic Checkout Button':
                  style = HELPER.designOptions2Style(
                    $self,
                    screenType,
                    style,
                    deOptions,
                    '.shopify-payment-button__button:hover',
                  );
                  break;
                default:
                  style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_add-to-cart:hover');
                  break;
              }
            }
          } else {
            changed = false;
          }
          break;
        case 'fontWeight':
          var deOptions = [getFontWeightDesignOption({ $activePanel })];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font-style':
          if (
            moduleName == '(P) Cart Button' ||
            moduleName == '(P) Dynamic Checkout Button' ||
            moduleName == '(P) View More'
          ) {
            var fontItalic = '';
            var fontWeight = '';
            var fontUnderline = '';
            var fontStyle = $activePanel.find('#font-style').val();

            fontStyle = HELPER.trim(fontStyle, ',');
            var arrayFontStyle = fontStyle.split(',');
            for (var v = 0; v < arrayFontStyle.length; v++) {
              switch (arrayFontStyle[v]) {
                case 'bold':
                  fontWeight = 'bold';
                  break;
                case 'italic':
                  fontItalic = 'italic';
                  break;
                case 'underline':
                  fontUnderline = 'underline';
                  break;
              }
            }
            deOptions = [
              {
                key: 'font-weight',
                value: fontWeight,
              },
              {
                key: 'font-style',
                value: fontItalic,
              },
              {
                key: 'text-decoration',
                value: fontUnderline,
              },
            ];

            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          } else {
            changed = false;
          }
          break;
        case 'spacing-symbol': {
          const newValue = $activePanel.find('#spacing-symbol').val();
          const oldValue = HELPER.getValueFromCSS($self, style, 'padding-left', screenType, '.gf_breadcrumbs-symbol');
          if (newValue != oldValue) {
            const deOptions = [
              {
                key: 'padding-right',
                value: newValue,
              },
              {
                key: 'padding-left',
                value: newValue,
              },
            ];
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_breadcrumbs-symbol');
            changed = true;
          }
          break;
        }
        case 'page-font-weight': {
          const newValue = $activePanel.find('#page-font-weight').val();
          const oldValue = HELPER.getValueFromCSS(
            $self,
            style,
            'font-weight',
            screenType,
            '.gf_breadcrumbs-link.gf_current-page',
          );
          if (newValue != oldValue) {
            const deOptions = [
              {
                key: 'font-weight',
                value: newValue,
              },
            ];
            style = HELPER.designOptions2Style(
              $self,
              screenType,
              style,
              deOptions,
              '.gf_breadcrumbs-link.gf_current-page',
            );
            changed = true;
          }
          break;
        }
        case 'page-font-size': {
          const newValue = $activePanel.find('#page-font-size').val();
          const oldValue = HELPER.getValueFromCSS(
            $self,
            style,
            'font-size',
            screenType,
            '.gf_breadcrumbs-link.gf_current-page',
          );
          if (newValue != oldValue) {
            const deOptions = [
              {
                key: 'font-size',
                value: newValue,
              },
            ];
            style = HELPER.designOptions2Style(
              $self,
              screenType,
              style,
              deOptions,
              '.gf_breadcrumbs-link.gf_current-page',
            );
            changed = true;
          }
          break;
        }
        case 'page-color': {
          const newValue = $activePanel.find('#page-color').val();
          const oldValue = HELPER.getValueFromCSS(
            $self,
            style,
            'color',
            screenType,
            '.gf_breadcrumbs-link.gf_current-page',
          );
          if (newValue != oldValue) {
            const deOptions = [
              {
                key: 'color',
                value: newValue,
              },
            ];
            style = HELPER.designOptions2Style(
              $self,
              screenType,
              style,
              deOptions,
              '.gf_breadcrumbs-link.gf_current-page',
            );
            changed = true;
          }
          break;
        }
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }
      break;
    case '(P) File Upload': {
      const $targetSelector = $element.find('.gf_btn-upload');
      const $targetSecondary = $targetSelector.find('.gf_btn-secondarytext');
      switch (inputId) {
        case 'width': {
          const deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'height': {
          const deOptions = [
            {
              key: 'height',
              value: $activePanel.find('#height').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'previewWidth': {
          const $previewTarget = $element.find('.gf_upload-preview');
          const previewWidth = $activePanel.find('[name="previewWidth"]').val();
          const deOptions = [
            {
              key: 'width',
              value: previewWidth,
            },
          ];
          style = HELPER.designOptions2Style($previewTarget, screenType, style, deOptions, '.gf_upload-preview');
          break;
        }
        case 'previewHeight': {
          const $previewTarget = $element.find('.gf_file-upload');
          const previewHeight = $activePanel.find('[name="previewHeight"]').val();
          const deOptions = [
            {
              key: 'height',
              value: previewHeight,
            },
          ];
          style = HELPER.designOptions2Style($previewTarget, screenType, style, deOptions, '.gf_upload-preview');
          break;
        }
        case 'font-size': {
          const deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'secondarySize': {
          const deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#secondarySize').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSecondary, screenType, style, deOptions, '.gf_btn-secondarytext');
          break;
        }
        case 'font': {
          const deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'secondaryFont': {
          const deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#secondaryFont').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSecondary, screenType, style, deOptions, '.gf_btn-secondarytext');
          break;
        }
        case 'textTransform': {
          const deOptions = [
            {
              key: 'text-transform',
              value: $activePanel.find('#textTransform').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'secondaryTextTransform': {
          const deOptions = [
            {
              key: 'text-transform',
              value: $activePanel.find('#secondaryTextTransform').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSecondary, screenType, style, deOptions, '.gf_btn-secondarytext');
          break;
        }
        case 'color': {
          const deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'secondaryColor': {
          const deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#secondaryColor').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSecondary, screenType, style, deOptions, '.gf_btn-secondarytext');
          break;
        }
        case 'button-color': {
          const buttonColor = $activePanel.find('#button-color').val();
          const deOptions = [
            {
              key: 'background-color',
              value: buttonColor,
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'button-color-hover':
        case 'text-color-hover': {
          const deOptions = [
            {
              key: 'background-color',
              value: $activePanel.find('[name="button-color-hover"]').val(),
            },
            {
              key: 'color',
              value: $activePanel.find('[name="text-color-hover"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload:hover');
          break;
        }
        case 'font-style': {
          let fontItalic = '';
          let fontWeight = '';
          let fontUnderline = '';
          let fontStyle = $activePanel.find('#font-style').val();

          fontStyle = HELPER.trim(fontStyle, ',');
          const arrayFontStyle = fontStyle.split(',');
          for (let v = 0; v < arrayFontStyle.length; v++) {
            switch (arrayFontStyle[v]) {
              case 'bold':
                fontWeight = 'bold';
                break;
              case 'italic':
                fontItalic = 'italic';
                break;
              case 'underline':
                fontUnderline = 'underline';
                break;
            }
          }
          const deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: fontUnderline,
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        case 'secondaryFontStyle': {
          let fontItalic = '';
          let fontWeight = '';
          let fontUnderline = '';
          let fontStyle = $activePanel.find('#secondaryFontStyle').val();

          fontStyle = HELPER.trim(fontStyle, ',');
          const arrayFontStyle = fontStyle.split(',');
          for (let v = 0; v < arrayFontStyle.length; v++) {
            switch (arrayFontStyle[v]) {
              case 'bold':
                fontWeight = 'bold';
                break;
              case 'italic':
                fontItalic = 'italic';
                break;
              case 'underline':
                fontUnderline = 'underline';
                break;
            }
          }
          const deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: fontUnderline,
            },
          ];
          style = HELPER.designOptions2Style($targetSecondary, screenType, style, deOptions, '.gf_btn-secondarytext');
          break;
        }
        case 'isNewLine': {
          const isNewLine = $activePanel.find('#isNewLine').val();
          const deOptions = [
            {
              key: 'flex-direction',
              value: isNewLine == '1' ? 'column' : 'row',
            },
          ];
          style = HELPER.designOptions2Style($targetSelector, screenType, style, deOptions, '.gf_btn-upload');
          break;
        }
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }
      break;
    }
    case '(P) Image':
    case '(A) Image':
    case '(P) Image List': {
      const $badgeAnchor = $self.siblings('.gf_product-badge-anchor');
      let degVal = $activePanel.find('#badgeRotateFrame').val(),
        listTransForm = '';
      const rotateDeg = degVal ? parseInt(degVal) : 0;
      const positionSelected = $activePanel.find('#badgePosition').val();
      switch (inputId) {
        case 'border-active':
        case 'border-active-color':
          if (moduleName == '(P) Image List') {
            const activeBorder = $activePanel.find('#border-active').val();
            if (activeBorder == '1' || activeBorder == 1) {
              const borderWidth = '2px';
              let borderColor = '';
              borderColor = $activePanel.find('#border-active-color').val();
              // borderWidth = $activePanel.find('#border-active-size').val();
              var shadowVal = {
                blur: 0,
                color: borderColor,
                spread: parseInt(borderWidth),
                type: '',
                x: '0',
                y: '0',
              };

              var deOptions = [
                {
                  key: 'box-shadow',
                  value: shadowVal,
                },
              ];
              const classBorderActive = '.gf_product-image-thumbactive .gf_product-image-thumb';
              const $borderActive = $element.find(classBorderActive);
              style = HELPER.designOptions2Style($borderActive, screenType, style, deOptions, classBorderActive);
            } else {
              changed = false;
            }
          } else {
            changed = false;
          }

          break;

        case 'width':
          if (moduleName == '(P) Image List') {
            let width = $activePanel.find('#width').val();
            if (width == '') {
              width = 'auto';
            }
            var deOptions = [
              {
                key: 'width',
                value: width,
              },
            ];
          } else {
            var deOptions = [
              {
                key: 'width',
                value: $activePanel.find('#width').val(),
              },
            ];
          }

          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'height':
          if (moduleName == '(P) Image List') {
            var height = $activePanel.find('#height').val();
            if (height == '') {
              height = 'auto';
            }
            var deOptions = [
              {
                key: 'height',
                value: height,
              },
            ];
          } else {
            var deOptions = [
              {
                key: 'height',
                value: $activePanel.find('#height').val(),
              },
            ];
          }

          style = HELPER.designOptions2Style($self, screenType, style, deOptions);

          if (moduleName == '(P) Image List') {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-video-thumb');
          }
          break;
        case 'spacing':
          if (moduleName == '(P) Image List') {
            var deOptions = [
              {
                key: 'margin-right',
                value: $activePanel.find('#spacing').val(),
              },
              {
                key: 'margin-bottom',
                value: $activePanel.find('#spacing').val(),
              },
            ];
          } else {
            changed = false;
          }

          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'badgeColor':
          var color = $activePanel.find('#badgeColor').val();
          var deOptionsColor = [
            {
              key: 'color',
              value: color,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsColor, '.gf_badge-text-wrap');
          break;
        case 'firstBackgound':
        case 'secondBackgound':
          if (moduleName == '(P) Image') {
            const firstBackgound = $activePanel.find('#firstBackgound').val();
            const secondBackgound = $activePanel.find('#secondBackgound').val();
            let deOptionsBG = [];
            let singleBg = '';
            if (firstBackgound != 'none' && secondBackgound == 'none') {
              singleBg = firstBackgound;
              deOptionsBG = [
                {
                  key: 'background',
                  value: singleBg,
                },
              ];
            } else if (firstBackgound == 'none' && secondBackgound != 'none') {
              singleBg = secondBackgound;
              deOptionsBG = [
                {
                  key: 'background',
                  value: singleBg,
                },
              ];
            } else if (firstBackgound != 'none' && secondBackgound != 'none') {
              deOptionsBG = [
                {
                  key: 'background',
                  value: singleBg,
                },
                {
                  key: 'background',
                  value: `-webkit-linear-gradient(to right, ${firstBackgound}, ${secondBackgound})`,
                },
                {
                  key: 'background',
                  value: `linear-gradient(to right, ${firstBackgound}, ${secondBackgound})`,
                },
              ];
            }
            style = HELPER.designOptions2Style($self, screenType, style, deOptionsBG, '.gf_badge-text-wrap');
          }
          break;
        case 'badgeWidth':
          var badgeWidth = $activePanel.find('#badgeWidth').val();
          var deOptionsBWidth = [
            {
              key: 'width',
              value: badgeWidth,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsBWidth, '.gf_product-badge-anchor');
          break;
        case 'percentagePrice': {
          const percentagePrice = $activePanel.find('#percentagePrice').val();
          let badgeWidth = '60px';
          if (percentagePrice == '1') {
            badgeWidth = 'auto';
          } else {
            badgeWidth = '60px';
          }
          const deOptions = [
            {
              key: 'width',
              value: badgeWidth,
            },
          ];
          $activePanel.find('#badgeWidth').attr('value', badgeWidth).val(badgeWidth).trigger('value-change');
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_product-badge-anchor');
          break;
        }
        case 'badgeHeight':
          var badgeHeight = $activePanel.find('#badgeHeight').val();
          var deOptionsBHeight = [
            {
              key: 'height',
              value: badgeHeight,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsBHeight, '.gf_product-badge-anchor');
          break;
        case 'badgeFontSize':
          var badgeFontSize = $activePanel.find('#badgeFontSize').val();
          var deOptionsFontSize = [
            {
              key: 'font-size',
              value: badgeFontSize,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsFontSize, '.gf_badge-text-wrap');
          break;
        case 'badgeTextLineHeight':
          var badgeTextLineHeight = $activePanel.find('#badgeTextLineHeight').val();
          var deOptionsLineHeight = [
            {
              key: 'line-height',
              value: badgeTextLineHeight,
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsLineHeight, '.gf_badge-text-wrap');
          break;
        case 'badgeFont':
          var deOptionsFont = [
            {
              key: 'font-family',
              value: $activePanel.find('#badgeFont').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsFont, '.gf_badge-text-wrap');
          break;
        case 'badgePositionTop':
          var deOptionsPTop = [];
          if ($badgeAnchor.hasClass('gf_pb_top-left') || $badgeAnchor.hasClass('gf_pb_top-right')) {
            deOptionsPTop = [
              {
                key: 'top',
                value: $activePanel.find('#badgePositionTop').val(),
              },
            ];
          }
          style = HELPER.designOptions2Style(
            $badgeAnchor,
            screenType,
            style,
            deOptionsPTop,
            '.gf_product-badge-anchor',
          );
          break;
        case 'badgePositionBottom':
          var deOptionsPBottom = [];
          if ($badgeAnchor.hasClass('gf_pb_bottom-left') || $badgeAnchor.hasClass('gf_pb_bottom-right')) {
            deOptionsPBottom = [
              {
                key: 'bottom',
                value: $activePanel.find('#badgePositionBottom').val(),
              },
            ];
          }
          style = HELPER.designOptions2Style(
            $badgeAnchor,
            screenType,
            style,
            deOptionsPBottom,
            '.gf_product-badge-anchor',
          );
          break;
        case 'badgePositionLeft':
          var deOptionsPLeft = [];
          if ($badgeAnchor.hasClass('gf_pb_top-left') || $badgeAnchor.hasClass('gf_pb_bottom-left')) {
            deOptionsPLeft = [
              {
                key: 'left',
                value: $activePanel.find('#badgePositionLeft').val(),
              },
            ];
          }
          style = HELPER.designOptions2Style(
            $badgeAnchor,
            screenType,
            style,
            deOptionsPLeft,
            '.gf_product-badge-anchor',
          );
          break;
        case 'badgePositionRight':
          var deOptionsPRight = [];
          if ($badgeAnchor.hasClass('gf_pb_top-right') || $badgeAnchor.hasClass('gf_pb_bottom-right')) {
            deOptionsPRight = [
              {
                key: 'right',
                value: $activePanel.find('#badgePositionRight').val(),
              },
            ];
          }
          style = HELPER.designOptions2Style(
            $badgeAnchor,
            screenType,
            style,
            deOptionsPRight,
            '.gf_product-badge-anchor',
          );
          break;
        case 'badgePosition': {
          let deOptionsBgStyle = [];
          listTransForm = `rotate(${rotateDeg}deg)`;
          if (positionSelected == 'top-left') {
            deOptionsBgStyle = [
              {
                key: 'top',
                value: $activePanel.find('#badgePositionTop').val(),
              },
              {
                key: 'left',
                value: $activePanel.find('#badgePositionLeft').val(),
              },
              {
                key: 'bottom',
                value: 'unset',
              },
              {
                key: 'right',
                value: 'unset',
              },
              {
                key: 'transform',
                value: listTransForm,
              },
            ];
          } else if (positionSelected == 'top-right') {
            deOptionsBgStyle = [
              {
                key: 'top',
                value: $activePanel.find('#badgePositionTop').val(),
              },
              {
                key: 'right',
                value: $activePanel.find('#badgePositionRight').val(),
              },
              {
                key: 'bottom',
                value: 'unset',
              },
              {
                key: 'left',
                value: 'unset',
              },
              {
                key: 'transform',
                value: listTransForm,
              },
            ];
          } else if (positionSelected == 'bottom-right') {
            deOptionsBgStyle = [
              {
                key: 'bottom',
                value: $activePanel.find('#badgePositionBottom').val(),
              },
              {
                key: 'right',
                value: $activePanel.find('#badgePositionRight').val(),
              },
              {
                key: 'top',
                value: 'unset',
              },
              {
                key: 'left',
                value: 'unset',
              },
              {
                key: 'transform',
                value: listTransForm,
              },
            ];
          } else if (positionSelected == 'bottom-left') {
            deOptionsBgStyle = [
              {
                key: 'bottom',
                value: $activePanel.find('#badgePositionBottom').val(),
              },
              {
                key: 'left',
                value: $activePanel.find('#badgePositionLeft').val(),
              },
              {
                key: 'top',
                value: 'unset',
              },
              {
                key: 'right',
                value: 'unset',
              },
              {
                key: 'transform',
                value: listTransForm,
              },
            ];
          } else if (positionSelected == 'center') {
            deOptionsBgStyle = [
              {
                key: 'top',
                value: '50%',
              },
              {
                key: 'left',
                value: '50%',
              },
              {
                key: 'bottom',
                value: 'unset',
              },
              {
                key: 'right',
                value: 'unset',
              },
              {
                key: 'transform',
                value: `rotate(${rotateDeg}deg) translate(-50%, -50%)`,
              },
            ];
          }
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsBgStyle, '.gf_product-badge-anchor');
          break;
        }
        case 'badgeRotateFrame': {
          let deOptionsRotate = [];
          if (positionSelected == 'center') {
            const translateX = '-50%';
            const translateY = '-50%';
            listTransForm = `rotate(${rotateDeg}deg) translate(${translateX}, ${translateY})`;
            deOptionsRotate = [
              {
                key: 'transform',
                value: listTransForm,
              },
            ];
          } else {
            listTransForm = `rotate(${rotateDeg}deg)`;
            deOptionsRotate = [
              {
                key: 'transform',
                value: listTransForm,
              },
            ];
          }
          style = HELPER.designOptions2Style($self, screenType, style, deOptionsRotate, '.gf_product-badge-anchor');
          break;
        }
        case 'badgeRotateText': {
          const degVal = $activePanel.find('#badgeRotateText').val();
          const rotateDeg = degVal ? parseInt(degVal) : 0;
          const deOptionsTextRotate = [
            {
              key: 'transform',
              value: `rotate(${rotateDeg}deg)`,
            },
          ];
          style = HELPER.designOptions2Style(
            $self,
            screenType,
            style,
            deOptionsTextRotate,
            '.gf_product-badge-anchor span',
          );
          break;
        }
        case 'percentagePrice':
        case 'displayType': {
          const currency = getCurrency($element);
          const displayType = $activePanel.find('#displayType').val();
          let $PImageModule = $element.closest('[data-label="(P) Image"]');
          if ($PImageModule.length == 0) {
            $PImageModule = $element.closest('[data-icon="gpicon-product-image"]');
          }
          const $sellOffUnit = $PImageModule.find('.gf_badge-text-wrap').find('.data-saleoffunit');
          // var $sellOffValue = $PImageModule.find(".gf_badge-text-wrap").find("#data-saleoffvalue");
          if (displayType == 'number') {
            if ($activePanel.find('#textUnit').val() === '%') {
              $activePanel.find('#textUnit').val(currency).attr('value', currency).trigger('value-change');
              $element.find('.module').attr('data-displayunit', currency);
              $sellOffUnit.html(currency);
            }
          } else if (displayType == 'percentage') {
            $activePanel.find('#textUnit').val(currency).attr('value', '%').trigger('value-change');
            $element.find('.module').attr('data-displayunit', '%');
            $sellOffUnit.html('%');
          }
          break;
        }
      }

      if (changed) {
        _this.runStyle(style);
      }
      break;
    }
    case '(P) Variants':
      switch (inputId) {
        case 'width':
          var deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'height':
          var deOptions = [
            {
              key: 'height',
              value: $activePanel.find('#height').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'first-option':
          var option = $activePanel.find('#first-option').val();
          var deOptions = [
            {
              key: 'display',
              value: option == 1 ? 'block' : 'none',
            },
          ];
          for (var i = 0; i < devices.length; i++) {
            var screenDevice = devices[i];
            style = HELPER.designOptions2Style(
              $self,
              screenDevice,
              style,
              deOptions,
              '.gf_variants-option1',
              '',
              moduleName,
            );
          }
          break;
        case 'second-option':
          var option = $activePanel.find('#second-option').val();
          var deOptions = [
            {
              key: 'display',
              value: option == 1 ? 'block' : 'none',
            },
          ];
          for (var i = 0; i < devices.length; i++) {
            var screenDevice = devices[i];
            style = HELPER.designOptions2Style(
              $self,
              screenDevice,
              style,
              deOptions,
              '.gf_variants-option2',
              '',
              moduleName,
            );
          }
          break;
        case 'third-option':
          var option = $activePanel.find('#third-option').val();
          var deOptions = [
            {
              key: 'display',
              value: option == 1 ? 'block' : 'none',
            },
          ];
          for (var i = 0; i < devices.length; i++) {
            var screenDevice = devices[i];
            style = HELPER.designOptions2Style(
              $self,
              screenDevice,
              style,
              deOptions,
              '.gf_variants-option3',
              '',
              moduleName,
            );
          }
          break;
        default: // Fix cho v1
          var minWidthLabel = 'auto';
          if ($activePanel.find('#inlineSpacing').length > 0) {
            minWidthLabel = $activePanel.find('#inlineSpacing').val();
          }
          var nameLabel = 'label-';
          if ($activePanel.find('[name="label-font-size"]').length == 0) {
            // Fix cho V1
            // v1
            nameLabel = '';
          }
          deOptions = [
            {
              key: 'padding-bottom',
              value: $activePanel.find('[name="' + nameLabel + 'bottom"]').val(),
            },
            {
              key: 'font-size',
              value: $activePanel.find('[name="' + nameLabel + 'font-size"]').val(),
            },
            {
              key: 'line-height',
              value: $activePanel.find('[name="' + nameLabel + 'line-height"]').val(),
            },
            {
              key: 'font-family',
              value: $activePanel.find('[name="' + nameLabel + 'font"]').val(),
            },
            {
              key: 'color',
              value: $activePanel.find('[name="' + nameLabel + 'color"]').val(),
            },
            {
              key: 'min-width',
              value: minWidthLabel,
            },
            getFontWeightDesignOption({ $activePanel }),
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
      }

      if (changed) {
        _this.runStyle(style);
      }

      break;

    case '(P) Swatches':
      switch (inputId) {
        case 'width':
          var deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'height':
          var deOptions = [
            {
              key: 'height',
              value: $activePanel.find('#height').val(),
            },
            {
              key: 'line-height',
              value: $activePanel.find('#height').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('[name="font-size"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('[name="font"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('[name="color"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'label-bottom':
          var deOptions = [
            {
              key: 'padding-bottom',
              value: $activePanel.find('[name="label-bottom"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
          break;
        case 'label-font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('[name="label-font-size"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
          break;
        case 'label-line-height':
          var deOptions = [
            {
              key: 'line-height',
              value: $activePanel.find('[name="label-line-height"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
          break;
        case 'label-font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('[name="label-font"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
          break;
        case 'label-font-weight':
          var deOptions = [getFontWeightDesignOption({ $activePanel, inputSelector: '#label-font-weight' })];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
          break;
        case 'label-color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('[name="label-color"]').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
          break;
        case 'active-outline':
        case 'active-outline-size':
        case 'active-outline-color':
          if ($activePanel.find('#active-outline').length > 0) {
            const activeOutline = $activePanel.find('#active-outline').val();
            let outlineWidth = '0px';
            let outlineColor = 'transparent';
            if (activeOutline == '1' || activeOutline == 1) {
              outlineWidth = $activePanel.find('#active-outline-size').val();
              outlineColor = $activePanel.find('#active-outline-color').val();
            }
            var shadowVal = {
              blur: 0,
              color: outlineColor,
              spread: parseInt(outlineWidth),
              type: '',
              x: '0',
              y: '0',
            };
            deOptions = [
              {
                key: 'box-shadow',
                value: shadowVal,
              },
            ];
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_swatch.gf_selected');
          } else {
            changed = false;
          }
          break;
        case 'first-option':
          var option = $activePanel.find('#first-option').val();
          var deOptions = [
            {
              key: 'display',
              value: option == 1 ? 'block' : 'none',
            },
          ];
          for (var i = 0; i < devices.length; i++) {
            var screenDevice = devices[i];
            style = HELPER.designOptions2Style(
              $self,
              screenDevice,
              style,
              deOptions,
              '.gf_swatches-option1',
              '',
              moduleName,
            );
          }
          break;
        case 'second-option':
          var option = $activePanel.find('#second-option').val();
          var deOptions = [
            {
              key: 'display',
              value: option == 1 ? 'block' : 'none',
            },
          ];
          for (var i = 0; i < devices.length; i++) {
            var screenDevice = devices[i];
            style = HELPER.designOptions2Style(
              $self,
              screenDevice,
              style,
              deOptions,
              '.gf_swatches-option2',
              '',
              moduleName,
            );
          }
          break;
        case 'third-option':
          var option = $activePanel.find('#third-option').val();
          var deOptions = [
            {
              key: 'display',
              value: option == 1 ? 'block' : 'none',
            },
          ];
          for (var i = 0; i < devices.length; i++) {
            var screenDevice = devices[i];
            style = HELPER.designOptions2Style(
              $self,
              screenDevice,
              style,
              deOptions,
              '.gf_swatches-option3',
              '',
              moduleName,
            );
          }
          break;
        case 'fontWeight':
          var deOptions = [getFontWeightDesignOption({ $activePanel })];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;

        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }
      break;

    case '(P) Quantity':
      switch (inputId) {
        case 'height':
          var deOptions = [
            {
              key: 'height',
              value: $activePanel.find('#height').val(),
            },
            {
              key: 'line-height',
              value: $activePanel.find('#height').val(),
            },
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          if ($element.attr('data-ver') == '2') {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_pq_qty');
          } else {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          }
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          if ($element.attr('data-ver') == '2') {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_pq_qty');
          } else {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          }
          break;
        case 'color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color').val(),
            },
          ];
          if ($element.attr('data-ver') == '2') {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_pq_qty');
          } else {
            style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          }
          break;
        default:
          var paddingBottomLabel = '';

          var buttonWidth = $activePanel.find('#buttonWidth').val();
          var stretch = $activePanel.find('#stretch').val();
          var styleQuantity = $activePanel.find('#style').val();

          var widthInputQuantity = 'calc(100% - ' + buttonWidth + ' - ' + buttonWidth + ')';
          var maxWidthInputQuantity = 'calc(100% - ' + buttonWidth + ' - ' + buttonWidth + ')';
          if (styleQuantity == 'simple') {
            widthInputQuantity = '100%';
            maxWidthInputQuantity = '100%';
          }
          if (stretch == '0') {
            widthInputQuantity = $activePanel.find('#width').val();
          }
          var deOptions = [
            {
              key: 'width',
              value: widthInputQuantity,
            },
            {
              key: 'max-width',
              value: maxWidthInputQuantity,
            },
            getFontWeightDesignOption({ $activePanel }),
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, '.gf_pq_qty');

          var minWidthLabel = 'auto';
          if (styleQuantity == 'inline') {
            minWidthLabel = $activePanel.find('#label-spacing-inline').val();
            paddingBottomLabel = '0px';
          }
          var deOptions = [
            {
              key: 'min-width',
              value: minWidthLabel,
            },
          ];

          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');

          if (!paddingBottomLabel && paddingBottomLabel != '0px') {
            var paddingBottomLabel = $activePanel.find('[name="label-bottom"]').val();
          }

          var deOptions = [
            {
              key: 'padding-bottom',
              value: paddingBottomLabel,
            },
            {
              key: 'font-size',
              value: $activePanel.find('[name="label-font-size"]').val(),
            },
            {
              key: 'line-height',
              value: $activePanel.find('[name="label-line-height"]').val(),
            },
            {
              key: 'font-family',
              value: $activePanel.find('[name="label-font"]').val(),
            },
            {
              key: 'color',
              value: $activePanel.find('[name="label-color"]').val(),
            },
            getFontWeightDesignOption({ $activePanel, inputSelector: '#label-font-weight' }),
          ];
          style = HELPER.designOptions2Style($self, screenType, style, deOptions, 'label');
      }
      if (changed) {
        _this.runStyle(style);
      }
      break;
    case '(P) Stock Counter': {
      // (P) Stock Counter không được đăng ký moduleInfo (targetClass) trong app\editor\sidebar\module\register.js => dùng $element thay cho $self
      switch (inputId) {
        case 'width': {
          const deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style($element.find('.module'), screenType, style, deOptions, '.module');
          break;
        }
        case 'align_xs':
        case 'align_sm':
        case 'align_md':
        case 'align_lg': {
          const $module = $element.find('.module');
          const deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style($module, screenType, style, deOptions, '.module');
          break;
        }
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }
      break;
    }
    // COLLECTION 2019
    case 'Collection Banner':
      switch (inputId) {
        case 'height':
          var height = jQuery.trim($activePanel.find('input[name="height"]').val());
          if (height != undefined) {
            if (height != '' && height != 'auto') {
              var dragPlaceHolder = 50;

              deOptions.push(
                {
                  key: 'height',
                  value: height,
                },
                {
                  key: 'padding-top',
                  value: parseFloat(height) / 2 - dragPlaceHolder / 2 + 'px',
                },
                {
                  key: 'padding-bottom',
                  value: '10px',
                },
              );
            } else {
              var paddingTop = HELPER.getValueFromCSS($self, style, 'padding-top', screenType);
              var paddingBottom = HELPER.getValueFromCSS($self, style, 'padding-bottom', screenType);

              if (parseInt(paddingBottom) == 10) {
                paddingBottom = paddingTop;

                var dragPlaceHolder = 50;

                deOptions.push(
                  {
                    key: 'height',
                    value: 'auto',
                  },
                  {
                    key: 'padding-top',
                    value: parseInt(paddingTop) + 'px',
                  },
                  {
                    key: 'padding-bottom',
                    value: parseInt(paddingBottom) + 'px',
                  },
                );
              }
            }
          }
          style = HELPER.designOptions2Style($self, screenType, style, deOptions);
          break;
        default:
          changed = false;
      }

      setTimeout(function () {
        $element.data('gfoutline').updatePadding('top');
        $element.data('gfoutline').updatePadding('bottom');
      }, 300);

      if (changed) {
        _this.runStyle(style);
      }
      break;

    case 'Paginator':
      switch (inputId) {
        case 'font-style':
          var fontItalic = '';
          var fontWeight = '';
          var fontUnderline = '';
          var fontStyle = $activePanel.find('#font-style').val();
          if (fontStyle) {
            fontStyle = HELPER.trim(fontStyle, ',');
            var arrayFontStyle = fontStyle.split(',');
            for (var v = 0; v < arrayFontStyle.length; v++) {
              switch (arrayFontStyle[v]) {
                case 'bold':
                  fontWeight = 'bold';
                  break;
                case 'italic':
                  fontItalic = 'italic';
                  break;
                case 'underline':
                  fontUnderline = 'underline';
                  break;
              }
            }
          }

          var deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: fontUnderline,
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.page',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.deco',
          );

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.prev',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.next',
          );

          break;

        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.page',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.deco',
          );

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.prev',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.next',
          );

          break;

        case 'text_color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#text_color').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-paginator-wrapper',
          );

          break;

        case 'active_color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#active_color').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.current',
          );
          break;

        case 'btn-size':
        case 'btn-shape':
        case 'layout':
          var layout = $activePanel.find('#layout').val();
          var btnSize = layout == 'simple' ? 'auto' : $activePanel.find('#btn-size').val();

          var deOptions = [
            {
              key: 'width',
              value: btnSize,
            },
            {
              key: 'height',
              value: btnSize,
            },
            {
              key: 'line-height',
              value: btnSize,
            },
            {
              key: 'border-radius',
              value: $activePanel.find('#btn-shape').val() == 'square' ? '0px' : parseInt(btnSize) / 2 + 'px',
            },
            {
              key: 'border-style',
              value: layout == 'simple' ? 'none' : 'solid',
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.page',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.deco',
          );

          deOptions = [
            {
              key: 'width',
              value: 'auto',
            },
            {
              key: 'height',
              value: btnSize,
            },
            {
              key: 'line-height',
              value: btnSize,
            },
            {
              key: 'border-radius',
              value: $activePanel.find('#btn-shape').val() == 'square' ? '0px' : parseInt(btnSize) / 2 + 'px',
            },
            {
              key: 'padding-left',
              value: layout == 'simple' ? 'auto' : '10px',
            },
            {
              key: 'padding-right',
              value: layout == 'simple' ? 'auto' : '10px',
            },

            {
              key: 'border-style',
              value: layout == 'simple' ? 'none' : 'solid',
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.prev',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.next',
          );

          break;

        case 'btn-spacing':
        case 'align_lg':
        case 'align_md':
        case 'align_sm':
        case 'align_xs':
          var align = $activePanel.find('#align_' + screenType).val();
          var deOptions = [
            {
              key: 'margin',
              value:
                '0px ' +
                (align == 'right' ? '0px' : $activePanel.find('#btn-spacing').val()) +
                ' 5px ' +
                (align == 'left' ? '0px' : $activePanel.find('#btn-spacing').val()),
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.page',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.deco',
          );

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.prev',
          );
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-paginator-wrapper'),
            screenType,
            style,
            deOptions,
            'span.next',
          );

          break;
      }
      if (changed) {
        _this.runStyle(style);
      }

      break;

    case 'Collection Toolbar':
      switch (inputId) {
        case 'width':
          var deOptions = [
            {
              key: 'width',
              value: $activePanel.find('#width').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-toolbar-wrapper',
          );
          break;
        case 'height':
          var deOptions = [
            {
              key: 'height',
              value: $activePanel.find('#height').val(),
            },
            {
              key: 'line-height',
              value: $activePanel.find('#height').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-toolbar-wrapper',
          );
          break;
        case 'font-size_quantity':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size_quantity').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_product-quantity-wrapper',
          );
          break;
        case 'color_quantity':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color_quantity').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_product-quantity-wrapper',
          );
          break;
        case 'font_quantity':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font_quantity').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_product-quantity-wrapper',
          );
          break;
        case 'font-size_selector':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size_selector').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            'select',
          );
          break;
        case 'color_selector':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#color_selector').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            'select',
          );
          break;
        case 'font_selector':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font_selector').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-toolbar-wrapper'),
            screenType,
            style,
            deOptions,
            'select',
          );
          break;
        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }

      break;

    case 'Collection Title':
      switch (inputId) {
        case 'font-style':
          var fontItalic = '';
          var fontWeight = '';
          var fontUnderline = '';
          var fontStyle = $activePanel.find('#font-style').val();
          if (fontStyle) {
            fontStyle = HELPER.trim(fontStyle, ',');
            var arrayFontStyle = fontStyle.split(',');
            for (var v = 0; v < arrayFontStyle.length; v++) {
              switch (arrayFontStyle[v]) {
                case 'bold':
                  fontWeight = 'bold';
                  break;
                case 'italic':
                  fontItalic = 'italic';
                  break;
                case 'underline':
                  fontUnderline = 'underline';
                  break;
              }
            }
          }

          var deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: fontUnderline,
            },
          ];

          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;
        case 'line-height':
          var deOptions = [
            {
              key: 'line-height',
              value: $activePanel.find('#line-height').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;
        case 'letter-spacing':
          var deOptions = [
            {
              key: 'letter-spacing',
              value: $activePanel.find('#letter-spacing').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;

        case 'text-color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#text-color').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;
        case 'textTransform':
          var deOptions = [
            {
              key: 'text-transform',
              value: $activePanel.find('#textTransform').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-title-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-title h1',
          );
          break;
        default:
          changed = false;
      }
      if (changed) {
        _this.runStyle(style);
      }

      break;

    case 'Collection Desc':
      switch (inputId) {
        case 'font-style':
          var fontItalic = '';
          var fontWeight = '';
          var fontUnderline = '';
          var fontStyle = $activePanel.find('#font-style').val();
          if (fontStyle) {
            fontStyle = HELPER.trim(fontStyle, ',');
            var arrayFontStyle = fontStyle.split(',');
            for (var v = 0; v < arrayFontStyle.length; v++) {
              switch (arrayFontStyle[v]) {
                case 'bold':
                  fontWeight = 'bold';
                  break;
                case 'italic':
                  fontItalic = 'italic';
                  break;
                case 'underline':
                  fontUnderline = 'underline';
                  break;
              }
            }
          }

          var deOptions = [
            {
              key: 'font-weight',
              value: fontWeight,
            },
            {
              key: 'font-style',
              value: fontItalic,
            },
            {
              key: 'text-decoration',
              value: fontUnderline,
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );
          break;
        case 'font-size':
          var deOptions = [
            {
              key: 'font-size',
              value: $activePanel.find('#font-size').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );

          break;
        case 'line-height':
          var deOptions = [
            {
              key: 'line-height',
              value: $activePanel.find('#line-height').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );

          break;
        case 'letter-spacing':
          var deOptions = [
            {
              key: 'letter-spacing',
              value: $activePanel.find('#letter-spacing').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );

          break;
        case 'text-color':
          var deOptions = [
            {
              key: 'color',
              value: $activePanel.find('#text-color').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );

          break;
        case 'font':
          var deOptions = [
            {
              key: 'font-family',
              value: $activePanel.find('#font').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );

          break;
        case 'textTransform':
          var deOptions = [
            {
              key: 'text-transform',
              value: $activePanel.find('#textTransform').val(),
            },
          ];
          style = HELPER.designOptions2Style(
            $self.find('.gf_collection-description-wrapper'),
            screenType,
            style,
            deOptions,
            '.gf_collection-banner-description',
          );

          break;
        default:
          changed = false;
      }

      if (changed) {
        _this.runStyle(style);
      }

      break;
  }
}
